import React from "react";

import { Container } from "@mui/material";

function PrivacyPolicy() {
  return (
    <Container className="about-container mt-5">
      <h1>Privacy Policy</h1>
      <hr></hr>
      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Information:</strong> First Name , Last Name, email address, phone
          number (optional) and payment details.
        </li>
        <li>
          <strong>Account Information:</strong> Username, password, and order
          history.
        </li>
        <li>
          <strong>Transaction Information:</strong> Purchase details, payment
          status.
        </li>
        <li>
          <strong>Technical Information:</strong> IP address, browser type,
          device information, and cookies.
        </li>
        <li>
          <strong>Communication Data:</strong> Emails, chats, and feedback
          messages.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Process and fulfill your orders.</li>
        <li>Improve our website, products, and services.</li>
        <li>Provide customer support and respond to inquiries.</li>
        <li>
          Send promotional emails and special offers (you can opt-out anytime).
        </li>
        <li>Prevent fraud and ensure the security of our platform.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      <h2>3. How We Share Your Information</h2>
      <ul>
        <li>
          <strong>Service Providers:</strong> Payment processors, delivery
          services, and IT support.
        </li>
        <li>
          <strong>Legal Authorities:</strong> If required by law, regulation, or
          legal process.
        </li>
        <li>
          <strong>Business Transfers:</strong> In case of a merger, sale, or
          acquisition of our company.
        </li>
      </ul>

      <h2>4. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to enhance your
        browsing experience. You can manage cookie preferences through your
        browser settings.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your data
        from unauthorized access, alteration, or loss. However, no online
        platform is completely secure.
      </p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>Access, update, or delete your personal data.</li>
        <li>Withdraw consent for marketing communications.</li>
        <li>Request information about how we process your data.</li>
      </ul>

      <h2>7. Third-Party Links</h2>
      <p>
        Our website may contain links to third-party sites. We are not
        responsible for their privacy practices.
      </p>

      <h2>8. Children's Privacy</h2>
      <p>
        Our services are not intended for children under 18. We do not knowingly
        collect data from children.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page with an updated <b>16 March 2025 .</b>
      </p>
    </Container>
  );
}

export default PrivacyPolicy;
